import { Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import Screen from '@/karehero-app/explore/Screen';
import { DOCUMENTS } from '@/karehero-app/explore/benefits-calculator/BenefitsCalculator.content';
import {
  ConfirmPair,
  Note,
  ProposalRow,
  WorkingBanner,
} from '@/karehero-app/explore/benefits-calculator/Parts';

// Section E. Extraction scoped to one question, which is the de-risking
// suggestion from the 5 Aug session: "get the awards off this letter" is a far
// easier and safer job than "extract everything relevant", and it takes most of
// the edge off the fabrication risk.
//
// Two of the failure frames matter more than the success one. A document mode
// that cannot say "I could not read this" will quietly invent a figure, and a
// wrong number off a letter is the same class of harm as invented prose.

export const E1Ask = () => (
  <Screen
    title={DOCUMENTS.ask.title}
    footer={
      <Stack spacing={2}>
        <Button ariaLabel={DOCUMENTS.ask.photo} isFullWidth>
          {DOCUMENTS.ask.photo}
        </Button>
        <Button
          ariaLabel={DOCUMENTS.ask.upload}
          variant='secondary'
          isFullWidth
        >
          {DOCUMENTS.ask.upload}
        </Button>
        <Button ariaLabel={DOCUMENTS.ask.skip} variant='link' isFullWidth>
          {DOCUMENTS.ask.skip}
        </Button>
      </Stack>
    }
  >
    <Typography variant='body2' color='text.secondary'>
      {DOCUMENTS.ask.body}
    </Typography>
  </Screen>
);
E1Ask.displayName = 'E1Ask';

export const E2Reading = () => (
  <Screen title={DOCUMENTS.reading.title} subtitle={DOCUMENTS.reading.body}>
    <Stack sx={{ alignItems: 'flex-start' }} spacing={2}>
      <WorkingBanner label={DOCUMENTS.reading.filename} />
      <Note
        title='Only one thing'
        icon='images'
        body='We are looking for what she already gets. We are not reading the rest of the letter.'
      />
    </Stack>
  </Screen>
);
E2Reading.displayName = 'E2Reading';

export const E3Found = () => (
  <Screen
    title={DOCUMENTS.found.title}
    subtitle={DOCUMENTS.found.body}
    footer={
      <ConfirmPair
        confirm={DOCUMENTS.found.confirm}
        change={DOCUMENTS.found.reject}
      />
    }
  >
    <ProposalRow
      question={DOCUMENTS.found.row.question}
      value={DOCUMENTS.found.row.value}
      said={DOCUMENTS.found.row.source}
      saidPrefix='On the letter'
    />
  </Screen>
);
E3Found.displayName = 'E3Found';

export const E4Unreadable = () => (
  <Screen
    title={DOCUMENTS.unreadable.title}
    footer={
      <ConfirmPair
        confirm={DOCUMENTS.unreadable.retake}
        change={DOCUMENTS.unreadable.instead}
      />
    }
  >
    <Note
      title='No answer taken from this'
      tone='warn'
      icon='circle-exclamation'
      body={DOCUMENTS.unreadable.body}
    />
  </Screen>
);
E4Unreadable.displayName = 'E4Unreadable';

export const E5WrongDoc = () => (
  <Screen
    title={DOCUMENTS.wrongDoc.title}
    footer={
      <ConfirmPair
        confirm={DOCUMENTS.wrongDoc.retake}
        change={DOCUMENTS.wrongDoc.instead}
      />
    }
  >
    <Note
      title='Read, and not used'
      tone='warn'
      icon='circle-question'
      body={DOCUMENTS.wrongDoc.body}
    />
  </Screen>
);
E5WrongDoc.displayName = 'E5WrongDoc';
